import { Icon } from '@/components/icons/Icon'
import { isIconType } from '@/defs/icon'

type Props = {
  text: string
}

type PartProps = {
  type: 'icon' | 'text'
  value: string
}

const REGEX = /\{([A-Za-z0-9/]+)\}/

const oracleSymbols = (text: string): PartProps[] =>
  text
    .split(REGEX)
    .map((value, i) =>
      i % 2 ? { type: 'icon' as const, value: value.toLowerCase() } : { type: 'text' as const, value },
    )
    .filter(({ value }) => value)

const Part = ({ type, value }: PartProps) => {
  if (type === 'text') return value
  const icon = value === 't' ? 'mtg-tap' : `mtg-${value.replaceAll('/', '')}`
  if (isIconType(icon)) return <Icon name={icon} />
  return `{${value}}`
}

export const TextWithSymbols = ({ text }: Props) => oracleSymbols(text).map((part, key) => <Part {...part} key={key} />)
